<template>
  <div class="p-1">
     <div-table :config="configList" :idWharhouse="idWharhouse" :currentUser="currentUser" :data="warehouses" @reset="reset"  @refresh="refresh" @filtrer="filtrer" @search="search" :loading="loading" :paginate="paginate" @paginatation="paginatation"></div-table>
  </div>
</template>

<script>
import config from './config'
export default {
  props: {
     currentUser: { type: Object},
     idWharhouse: { type: Object},
   },
  data() {
    return {
       configList: config.list,
       loading:false,
       content: {},
       warehouses:[],
      // currentUser: {},
       limit: 50,
       paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 1,
        per_page: 0,
       },
    };
  },
  async mounted() {
    //await this.getUser();
    this.getWarehouses({ limit: this.limit });
    console.log(this.content)
  },

  filters: {},
  methods: {
    async getWarehouses(filters) {
      filters.all=true;
      const res = await this.$server.search("warehouses", filters);
      if (res.content.results) {
        this.warehouses = res.content.results;
        this.warehouses.forEach(function (warehouse) {
          warehouse.zones = this.ZonesNames(warehouse.zones);
          warehouse.autoConfirm = this.AutoConfirmBadge(warehouse);
        }.bind(this));
        this.warehouses=this.sortByAttribute(this.warehouses, 'country', '_id')
        this.warehouses.total = res.content.total;
        this.warehouses.lastpage = res.content.last_page;
        this.warehouses.per_page = res.content.per_page;
        this.warehouses.currentpage = res.content.current_page;
      } else{ this.warehouses = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}}
    },
    ZonesNames(data){
      let zone="";
      for (let i in data) {
        zone+= '<a class="text-blue-600" target="_blank" href="/zones/edit/'+data[i]._id+'">'+data[i].name+'</a>'
        if(data.length-1 != i) zone+=" ,";
      }
      return zone;
    },
    // Badge HTML de l'état auto-confirm (colonne "auto_confirm" du tableau).
    // Les sous-warehouses (parent) ne portent pas de réglages -> cellule vide.
    // The cell answers one question: what decides this warehouse's orders?
    // Two independent systems can confirm - the NATIVE rule gate and the AI agent -
    // so both get a chip. Shown as small pills rather than words so a long list
    // reads by colour: green = acting, amber = watching only, grey = off.
    AutoConfirmBadge(warehouse){
      if(warehouse.parent) return '';   // sub-warehouses carry no settings

      const pill = (text, bg, fg, bd) =>
        '<span style="display:inline-block;background:' + bg + ';color:' + fg +
        ';border:1px solid ' + bd + ';padding:2px 9px;border-radius:9999px;' +
        'font-size:10.5px;font-weight:700;line-height:1.5;white-space:nowrap">' + text + '</span>';

      const GREEN = ['#ecfdf5', '#047857', '#a7f3d0'];
      const AMBER = ['#fffbeb', '#b45309', '#fde68a'];
      const GREY  = ['#f3f4f6', '#9ca3af', '#e5e7eb'];

      const out = [];

      // 1) native rule gate
      const nat = warehouse.autoConfirm_settings;
      if(nat && nat.enabled){
        const mode = String(nat.mode || 'strict').replace('phone+product+seller','phone+prod+seller');
        out.push(pill('Regle - ' + mode, GREEN[0], GREEN[1], GREEN[2]));
      } else {
        out.push(pill('Regle OFF', GREY[0], GREY[1], GREY[2]));
      }

      // 2) AI agent - live actually confirms, shadow only watches
      const ai = warehouse.aiCallCenter;
      if(ai && ai.active && ai.mode === 'live'){
        const thr = ai.threshold != null ? Math.round(ai.threshold * 100) + '%' : '';
        out.push(pill('IA live' + (thr ? ' ' + thr : ''), GREEN[0], GREEN[1], GREEN[2]));
      } else if(ai && ai.active){
        out.push(pill('IA shadow', AMBER[0], AMBER[1], AMBER[2]));
      } else {
        out.push(pill('IA OFF', GREY[0], GREY[1], GREY[2]));
      }

      return '<span style="display:inline-flex;flex-wrap:wrap;gap:4px;justify-content:center">' +
             out.join('') + '</span>';
    },
    sortByAttribute(array, ...attrs) {
          // generate an array of predicate-objects contains
          // property getter, and descending indicator
          let predicates = attrs.map(pred => {
            let descending = pred.charAt(0) === '-' ? -1 : 1;
            pred = pred.replace(/^-/, '');
            return {
              getter: o => o[pred],
              descend: descending
            };
          });
          // schwartzian transform idiom implementation. aka: "decorate-sort-undecorate"
          return array.map(item => {
            return {
              src: item,
              compareValues: predicates.map(predicate => predicate.getter(item))
            };
          })
          .sort((o1, o2) => {
            let i = -1, result = 0;
            while (++i < predicates.length) {
              if (o1.compareValues[i] < o2.compareValues[i]) result = -1;
              if (o1.compareValues[i] > o2.compareValues[i]) result = 1;
              if (result *= predicates[i].descend) break;
            }
            return result;
          })
          .map(item => item.src);
    },

    async refresh() {
      this.getWarehouses({ limit: this.limit });
    },

    /*********************************************************************************/
    async reset(data) {
      const filters = {
        limit: this.limit,
      };
      await this.getWarehouses(filters);
    },
    async search(data) {
      const search = {
        name: data,
      };
      const res = await this.$server.find("warehouses", search);
      console.log('resuult',res)
      if (res.content) {
        this.warehouses = res.content;
        this.warehouses.forEach(function (warehouse) {warehouse.zones = this.ZonesNames(warehouse.zones)}.bind(this));
        this.warehouses=this.sortByAttribute(this.warehouses, 'country', '_id')
        this.warehouses.total = res.content.total;
        this.warehouses.lastpage = res.content.last_page;
        this.warehouses.per_page = res.content.per_page;
        this.warehouses.currentpage = res.content.current_page;
      } else {this.warehouses = [];this.paginate={total: 0,currentpage: 1,lastpage: 1,per_page: 0,}}
    },
    async filtrer(data) {
      console.log(data);
      const filters = {
        name: data.name,
        limit: this.limit,
      };
       await this.getWarehouses(filters);
    },
    /****************************************************************************/
    async getUser() {
      const res = await this.$server.me("users");
      if (res.content) this.currentUser = res.content;
      else this.currentUser = [];
      console.log(this.currentUser);
    },
    /***************************************************************************************/
    async paginatation(direction){
      var page=0;
      if(direction == "next"){
         page=++this.paginate.currentpage;
      }else{
         page=--this.paginate.currentpage;
      }
       const filters = {
          page: page,
          limit: this.limit,
      };
      this.getWarehouses(filters);
    },
  },
};
</script>

<style>
</style>




